import { IDatasourceOptions } from 'core-ts-types';
import { Datasource, IDatasource, IDatasourceConstructor } from 'utility-ng-kernel';
import { WaitlistStatus } from '../builders/waitlist_status_builder';

export interface IWaitlistStatusDatasource extends IDatasource<WaitlistStatus> {}

angular.module('capability-ng-scheduler').factory('ngWaitlistStatusDatasource', (): IWaitlistStatusDatasource => {
  return new Datasource({
    builderType: WaitlistStatus
  });
});



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/course_scheduler/datasources/waitlist_status_datasource.ts